// PERMISSION - BEGIN
export const FETCH_PERMISSION_BEGIN = "FETCH_PERMISSION_BEGIN";
export const FETCH_PERMISSION_SUCCESS = "FETCH_PERMISSION_SUCCESS";
export const FETCH_PERMISSION_FAILURE = "FETCH_PERMISSION_FAILURE";
// PERMISSION - END

// DRAFT BULLETIN - BEGIN
export const FETCH_ALL_DRAFT_BULLETIN_BEGIN = "FETCH_ALL_DRAFT_BULLETIN_BEGIN";
export const FETCH_ALL_DRAFT_BULLETIN_SUCCESS =
  "FETCH_ALL_DRAFT_BULLETIN_SUCCESS";
export const FETCH_ALL_DRAFT_BULLETIN_FAILURE =
  "FETCH_ALL_DRAFT_BULLETIN_FAILURE";

export const FETCH_ALL_DRAFT_BULLETIN_RESET_DEFAULT_FILTER =
  "FETCH_ALL_DRAFT_BULLETIN_RESET_DEFAULT_FILTER";
export const FETCH_ALL_DRAFT_BULLETIN_SET_FILTER =
  "FETCH_ALL_DRAFT_BULLETIN_SET_FILTER";

export const FETCH_SINGLE_DRAFT_BULLETIN_BEGIN =
  "FETCH_SINGLE_DRAFT_BULLETIN_BEGIN";
export const FETCH_SINGLE_DRAFT_BULLETIN_SUCCESS =
  "FETCH_SINGLE_DRAFT_BULLETIN_SUCCESS";
export const FETCH_SINGLE_DRAFT_BULLETIN_FAILURE =
  "FETCH_SINGLE_DRAFT_BULLETIN_FAILURE";
// DRAFT BULLETIN - END

// PUBLISHED BULLETIN - BEGIN
export const FETCH_ALL_PUBLISHED_BULLETIN_BEGIN =
  "FETCH_ALL_PUBLISHED_BULLETIN_BEGIN";
export const FETCH_ALL_PUBLISHED_BULLETIN_SUCCESS =
  "FETCH_ALL_PUBLISHED_BULLETIN_SUCCESS";
export const FETCH_ALL_PUBLISHED_BULLETIN_FAILURE =
  "FETCH_ALL_PUBLISHED_BULLETIN_FAILURE";

export const FETCH_ALL_PUBLISHED_BULLETIN_RESET_DEFAULT_FILTER =
  "FETCH_ALL_PUBLISHED_BULLETIN_RESET_DEFAULT_FILTER";
export const FETCH_ALL_PUBLISHED_BULLETIN_SET_FILTER =
  "FETCH_ALL_PUBLISHED_BULLETIN_SET_FILTER";

export const FETCH_SINGLE_PUBLISHED_BULLETIN_BEGIN =
  "FETCH_SINGLE_PUBLISHED_BULLETIN_BEGIN";
export const FETCH_SINGLE_PUBLISHED_BULLETIN_SUCCESS =
  "FETCH_SINGLE_PUBLISHED_BULLETIN_SUCCESS";
export const FETCH_SINGLE_PUBLISHED_BULLETIN_FAILURE =
  "FETCH_SINGLE_PUBLISHED_BULLETIN_FAILURE";
// PUBLISHED BULLETIN - END

// RETIRED BULLETIN - BEGIN
export const FETCH_ALL_RETIRED_BULLETIN_BEGIN =
  "FETCH_ALL_RETIRED_BULLETIN_BEGIN";
export const FETCH_ALL_RETIRED_BULLETIN_SUCCESS =
  "FETCH_ALL_RETIRED_BULLETIN_SUCCESS";
export const FETCH_ALL_RETIRED_BULLETIN_FAILURE =
  "FETCH_ALL_RETIRED_BULLETIN_FAILURE";

export const FETCH_ALL_RETIRED_BULLETIN_RESET_DEFAULT_FILTER =
  "FETCH_ALL_RETIRED_BULLETIN_RESET_DEFAULT_FILTER";
export const FETCH_ALL_RETIRED_BULLETIN_SET_FILTER =
  "FETCH_ALL_RETIRED_BULLETIN_SET_FILTER";

export const FETCH_SINGLE_RETIRED_BULLETIN_BEGIN =
  "FETCH_SINGLE_RETIRED_BULLETIN_BEGIN";
export const FETCH_SINGLE_RETIRED_BULLETIN_SUCCESS =
  "FETCH_SINGLE_RETIRED_BULLETIN_SUCCESS";
export const FETCH_SINGLE_RETIRED_BULLETIN_FAILURE =
  "FETCH_SINGLE_RETIRED_BULLETIN_FAILURE";
// RETIRED BULLETIN - END

// SCHEDULED_PUBLISH BULLETIN - BEGIN
export const FETCH_ALL_SCHEDULED_PUBLISH_BULLETIN_BEGIN =
  "FETCH_ALL_SCHEDULED_PUBLISH_BULLETIN_BEGIN";
export const FETCH_ALL_SCHEDULED_PUBLISH_BULLETIN_SUCCESS =
  "FETCH_ALL_SCHEDULED_PUBLISH_BULLETIN_SUCCESS";
export const FETCH_ALL_SCHEDULED_PUBLISH_BULLETIN_FAILURE =
  "FETCH_ALL_SCHEDULED_PUBLISH_BULLETIN_FAILURE";

export const FETCH_ALL_SCHEDULED_PUBLISH_BULLETIN_RESET_DEFAULT_FILTER =
  "FETCH_ALL_SCHEDULED_PUBLISH_BULLETIN_RESET_DEFAULT_FILTER";
export const FETCH_ALL_SCHEDULED_PUBLISH_BULLETIN_SET_FILTER =
  "FETCH_ALL_SCHEDULED_PUBLISH_BULLETIN_SET_FILTER";

export const FETCH_SINGLE_SCHEDULED_PUBLISH_BULLETIN_BEGIN =
  "FETCH_SINGLE_SCHEDULED_PUBLISH_BULLETIN_BEGIN";
export const FETCH_SINGLE_SCHEDULED_PUBLISH_BULLETIN_SUCCESS =
  "FETCH_SINGLE_SCHEDULED_PUBLISH_BULLETIN_SUCCESS";
export const FETCH_SINGLE_SCHEDULED_PUBLISH_BULLETIN_FAILURE =
  "FETCH_SINGLE_SCHEDULED_PUBLISH_BULLETIN_FAILURE";
// SCHEDULED_PUBLISH BULLETIN - END

// PENDING BULLETIN - BEGIN
export const FETCH_ALL_PENDING_BULLETIN_BEGIN =
  "FETCH_ALL_PENDING_BULLETIN_BEGIN";
export const FETCH_ALL_PENDING_BULLETIN_SUCCESS =
  "FETCH_ALL_PENDING_BULLETIN_SUCCESS";
export const FETCH_ALL_PENDING_BULLETIN_FAILURE =
  "FETCH_ALL_PENDING_BULLETIN_FAILURE";

export const FETCH_ALL_PENDING_BULLETIN_RESET_DEFAULT_FILTER =
  "FETCH_ALL_PENDING_BULLETIN_RESET_DEFAULT_FILTER";
export const FETCH_ALL_PENDING_BULLETIN_SET_FILTER =
  "FETCH_ALL_PENDING_BULLETIN_SET_FILTER";

export const FETCH_SINGLE_PENDING_BULLETIN_BEGIN =
  "FETCH_SINGLE_PENDING_BULLETIN_BEGIN";
export const FETCH_SINGLE_PENDING_BULLETIN_SUCCESS =
  "FETCH_SINGLE_PENDING_BULLETIN_SUCCESS";
export const FETCH_SINGLE_PENDING_BULLETIN_FAILURE =
  "FETCH_SINGLE_PENDING_BULLETIN_FAILURE";
// PENDING BULLETIN - END

// OPEN REQUEST BULLETIN APPROVAL MODAL - BEGIN
export const REQUEST_DRAFT_BULLETIN_APPROVAL_MODAL_OPEN =
  "REQUEST_DRAFT_BULLETIN_APPROVAL_MODAL_OPEN";
export const REQUEST_DRAFT_BULLETIN_APPROVAL_MODAL_CLOSE =
  "REQUEST_DRAFT_BULLETIN_APPROVAL_MODAL_CLOSE";
// OPEN REQUEST BULLETIN APPROVAL MODAL - END

// OPEN PUBLISH BULLETIN MODAL - BEGIN
export const PUBLISH_BULLETIN_MODAL_OPEN = "PUBLISH_BULLETIN_MODAL_OPEN";
export const PUBLISH_BULLETIN_MODAL_CLOSE = "PUBLISH_BULLETIN_MODAL_CLOSE";
// OPEN PUBLISH BULLETIN MODAL - END

// OPEN AUDIT BULLETIN MODAL - BEGIN
export const AUDIT_BULLETIN_MODAL_OPEN = "AUDIT_BULLETIN_MODAL_OPEN";
export const AUDIT_BULLETIN_MODAL_CLOSE = "AUDIT_BULLETIN_MODAL_CLOSE";
// OPEN AUDIT BULLETIN MODAL - END

// OPEN MAILINGLIST BULLETIN MODAL - BEGIN
export const MAILINGLIST_BULLETIN_MODAL_OPEN = "MAILINGLIST_BULLETIN_MODAL_OPEN";
export const MAILINGLIST_BULLETIN_MODAL_CLOSE = "MAILINGLIST_BULLETIN_MODAL_CLOSE";
// OPEN MAILINGLIST BULLETIN MODAL - END

// OPEN EMAIL BULLETIN MODAL - BEGIN
export const EMAIL_BULLETIN_MODAL_OPEN = "EMAIL_BULLETIN_MODAL_OPEN";
export const EMAIL_BULLETIN_MODAL_CLOSE = "EMAIL_BULLETIN_MODAL_CLOSE";
// OPEN AUDIT BULLETIN MODAL - END

// OPEN RETIRE BULLETIN MODAL - BEGIN
export const RETIRE_BULLETIN_MODAL_OPEN = "RETIRE_BULLETIN_MODAL_OPEN";
export const RETIRE_BULLETIN_MODAL_CLOSE = "RETIRE_BULLETIN_MODAL_CLOSE";
// OPEN RETIRE BULLETIN MODAL - END

// OPEN BULLETIN DETAILS MODAL - BEGIN
export const BULLETIN_DETAIL_MODAL_OPEN = "BULLETIN_DETAIL_MODAL_OPEN";
export const BULLETIN_DETAIL_MODAL_CLOSE = "BULLETIN_DETAIL_MODAL_CLOSE";
// OPEN BULLETIN DETAILS MODAL - END

// OPEN BULLETIN VIEW MODAL - BEGIN
export const BULLETIN_VIEW_MODAL_OPEN = "BULLETIN_VIEW_MODAL_OPEN";
export const BULLETIN_VIEW_MODAL_CLOSE = "BULLETIN_VIEW_MODAL_CLOSE";
// OPEN BULLETIN VIEW MODAL - END

// OPEN  DELETE BULLETIN MODAL - BEGIN
export const DELETE_BULLETIN_MODAL_OPEN = " DELETE_BULLETIN_MODAL_OPEN";
export const DELETE_BULLETIN_MODAL_CLOSE = " DELETE_BULLETIN_MODAL_CLOSE";
// OPEN  DELETE BULLETIN MODAL - END

// ARGUMENT TABLE - BEGIN
export const FETCH_ALL_ARGUMENT_BEGIN = "FETCH_ALL_ARGUMENT_BEGIN";
export const FETCH_ALL_ARGUMENT_SUCCESS = "FETCH_ALL_ARGUMENT_SUCCESS";
export const FETCH_ALL_ARGUMENT_FAILURE = "FETCH_ALL_ARGUMENT_FAILURE";

// OPEN THUMB BULLETIN MODAL - BEGIN
export const THUMB_BULLETIN_MODAL_OPEN = "THUMB_BULLETIN_MODAL_OPEN";
export const THUMB_BULLETIN_MODAL_CLOSE = "THUMB_BULLETIN_MODAL_CLOSE";
// OPEN THUMB BULLETIN MODAL - END

export const FETCH_ALL_ARGUMENT_RESET_DEFAULT_FILTER =
  "FETCH_ALL_ARGUMENT_RESET_DEFAULT_FILTER";
export const FETCH_ALL_ARGUMENT_SET_FILTER = "FETCH_ALL_ARGUMENT_SET_FILTER";
// ARGUMENT TABLE - END
